import { render, staticRenderFns } from "./MemberApplicationPersonalDetails.vue?vue&type=template&id=0974a92e"
import script from "./MemberApplicationPersonalDetails.vue?vue&type=script&lang=js"
export * from "./MemberApplicationPersonalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports